import 
    React, 
    { 
        useState, 
 } from 'react';
import {
    useSelector,
    useDispatch
} from 'react-redux';
import {
    GoogleMap,
    TrafficLayer,
} from '@react-google-maps/api';

// Components
import MapSearchBar from '../../components/MapSearchBar';
import MapControlPanel from '../../components/MapControlPanel';
import GoogleMapsLoadScriptEnabler from "../components/GoogleMapsLoadScript";
import POIGeofences from "../../components/Geofences_POI";
import VehicleMarkers from "../../components/VehicleMarkers";
import ZoneGeofences from "../../components/Geofences_Zone";
import NotificationsDrawer from '../../components/NotificationsDrawer';
import EventInformationBox from '../../components/EventInformationBox';
import LiveCameraPopup from '../../components/LiveCameraPopup';
import LoadingModal from '../../../LoadingModal';

// Constants

// Handler
import { MapInitialiserWithVehicleAndGeofence } from '../handlers/MapInitialiserWithVehicleAndGeofence'
import { UnfocusMap } from '../handlers/UnfocusMap'

// Service

// Redux Action 

// Styles
import "../gmaps.css";
import { WebSocketFunc } from '../../../WebSocket';



const GoogleMapsMainPanel = () => {

    const dispatch = useDispatch()

    // State
    const [mapRef, setMapRef] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(true)

    // Redux Store
    const geofences = useSelector(state => state.containers.v3.geofences)
    const vehicles = useSelector(state => state.containers.v3.vehicles)
    const mdvr = useSelector(state => state.containers.v3.deviceMDVR)
    const mapControl = useSelector(state => state.containers.v3.mapControl)
    const selectedVID = useSelector(state => state.containers.v3.liveCamera.selectedMDVRID)
    const uroleid = useSelector(state => state.containers.v3.user.uroleid)
    // const loading = useSelector(state => state.containers.v3.style.loading.vehicleEvent)

    MapInitialiserWithVehicleAndGeofence(vehicles, geofences, mapControl, mapRef, mdvr)
    WebSocketFunc()

    return (
        <GoogleMap
            id='googles-map'
            mapContainerStyle={{
                height: '100vh'
            }}
            onLoad={ref => setMapRef(ref)}
            onDragStart={() => {
                UnfocusMap(dispatch)
            }}
            onTilesLoaded={() => setMapLoaded(false)}
        >
            {
                // loading
                mapLoaded
                &&
                <LoadingModal />
            }

            <POIGeofences mapRef={mapRef} />

            <VehicleMarkers mapRef={mapRef} />
            
            <EventInformationBox mapRef={mapRef} />

            <ZoneGeofences mapRef={mapRef} />

            {mapControl.UIControl.showLiveTraffic && <TrafficLayer />}

            <div className="searchBar">
                <MapSearchBar />
            </div>

            <div className="controlPanel">
                <MapControlPanel 
                    geofenceMarkerToggle = {true}
                    geofenceInfoToggle = {true}
                    liveTrafficTroggle = {true}
                    vehicleInfoToggle = {true}
                />
            </div>

            <NotificationsDrawer />

            {
                selectedVID && !(uroleid === 'FO')
                &&
                <LiveCameraPopup />
            }

        </GoogleMap>
    )
}

export default GoogleMapsLoadScriptEnabler(GoogleMapsMainPanel);